module.exports = __webpack_public_path__ + "static/media/reloj_amarillo.d594ff84.svg";